import { render, staticRenderFns } from "./GlovesCertificationBadges.vue?vue&type=template&id=dfd5d86c&scoped=true"
import script from "./GlovesCertificationBadges.vue?vue&type=script&lang=js"
export * from "./GlovesCertificationBadges.vue?vue&type=script&lang=js"
import style0 from "./GlovesCertificationBadges.vue?vue&type=style&index=0&id=dfd5d86c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd5d86c",
  null
  
)

export default component.exports